import React from 'react';
import { Typography, Box, Flex, Button } from '@fullstory/components';
import { generateRoutePath, ALERTS_NEW } from '@fullstory/routes';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import css from '../../styles/alerts/alertsOverlay.module.scss';

export const EmptyAlerts: React.FC<{
  orgId: string;
  segmentId: string;
}> = ({ orgId, segmentId }) => (
  <Box data-component="EmptyAlerts" paddingLeft={24} paddingRight={24}>
    <Flex justifyContent="space-between">
      <Typography variant="body1">
        <FormattedMessage defaultMessage="You have no alerts setup." id="Zk+mST" />
      </Typography>
      <Box paddingLeft={16}>
        <Link
          to={generateRoutePath(ALERTS_NEW, {
            orgId,
            segmentId,
          })}
          className={css.noUnderline}
        >
          <Button variant="fill-primary">
            <FormattedMessage defaultMessage="Create your first alert" id="uVpBsC" />
          </Button>
        </Link>
      </Box>
    </Flex>
  </Box>
);
